exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".option-left {\n  padding-left: 16px;\n  margin-top: 24px;\n}\n.option-right {\n  padding-right: 16px;\n  margin-top: 18px;\n}\n\n.option-left-down {\n  margin-top: 36px;\n}\n\n.option-right-down {\n  padding-right: 16px;\n  margin-top: 24px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/replication/replication.component.css
// module id = 825
// module chunks = 0